"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useEffect, useState } from "react"
import { cn } from "@/lib/utils"
import ProviderOnboardingBanner from "../ProviderOnboardingBanner"

/** MUI elevation 3 (scrolled fixed nav bar). */
const ELEVATION_3_SHADOW =
  "shadow-[0px_3px_3px_-2px_rgba(0,0,0,0.2),0px_3px_4px_0px_rgba(0,0,0,0.14),0px_1px_8px_0px_rgba(0,0,0,0.12)]"

/** MUI elevation 4 (the AppBar default used by the solid sticky variant). */
const ELEVATION_4_SHADOW =
  "shadow-[0px_2px_4px_-1px_rgba(0,0,0,0.2),0px_4px_5px_0px_rgba(0,0,0,0.14),0px_1px_10px_0px_rgba(0,0,0,0.12)]"

/**
 * Bar text color = MUI's computed contrastText for primary #00B2FF
 * (contrast ratio with white < 3 → dark text).
 */
const BAR_BASE_CLASSES = "z-[1100] w-full font-roboto text-[rgba(0,0,0,0.87)]"

/**
 * Replicates MUI <Container maxWidth="lg"> + <Toolbar disableGutters>:
 * centered 1200px container with 16px/24px gutters, 56px/64px min-height row.
 */
function NavToolbar({
  children,
  justifyBetween = false,
}: {
  children?: React.ReactNode
  justifyBetween?: boolean
}) {
  return (
    <div className="mx-auto w-full max-w-[1200px] px-4 min-[600px]:px-6">
      <div
        className={cn(
          "flex min-h-14 w-full flex-row items-center min-[600px]:min-h-16",
          justifyBetween && "justify-between",
        )}
      >
        {children}
      </div>
    </div>
  )
}

/**
 * Replaces MUI useScrollTrigger({ disableHysteresis: true, threshold: 0 }):
 * true as soon as the page is scrolled at all.
 */
function useScrolled() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return scrolled
}

// Fixed nav bar that turns solid + elevated once the page scrolls
function ElevationScrollBar({ children }: { children?: React.ReactNode }) {
  const scrolled = useScrolled()

  return (
    <>
      <header
        className={cn(
          BAR_BASE_CLASSES,
          "fixed top-0 right-0 left-0",
          scrolled
            ? `bg-[#00B2FF] ${ELEVATION_3_SHADOW}`
            : "bg-transparent shadow-none",
        )}
      >
        <NavToolbar>{children}</NavToolbar>
      </header>
      {scrolled ? <ProviderOnboardingBanner /> : null}
    </>
  )
}

// Client component wrapper
function AppBarContainer({
  startingBackgroundSolid,
  children,
  hideProviderOnboardingBanner,
}: {
  startingBackgroundSolid?: boolean
  children?: React.ReactNode
  hideProviderOnboardingBanner?: boolean
}) {
  if (startingBackgroundSolid) {
    return (
      <>
        <header
          className={cn(
            BAR_BASE_CLASSES,
            "sticky top-0 bg-[#00B2FF]",
            ELEVATION_4_SHADOW,
          )}
        >
          <NavToolbar justifyBetween>{children}</NavToolbar>
        </header>
        {!hideProviderOnboardingBanner && <ProviderOnboardingBanner />}
      </>
    )
  }

  return <ElevationScrollBar>{children}</ElevationScrollBar>
}

export default AppBarContainer
